import React from 'react';

import type { FlagIconProps } from './icon-types';

export const FlagCatalan: React.FC<FlagIconProps> = ({ size, isCircle = true }) => (
  <svg
    viewBox="0 0 126 126"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: size, height: size }}
  >
    <defs>
      {isCircle && (
        // eslint-disable-next-line react/no-unknown-property
        <mask id="circle" mask-type="luminance">
          <circle cx="63" cy="63" r="63" fill="white" />
        </mask>
      )}
    </defs>
    <g mask={isCircle ? 'url(#circle)' : undefined}>
      <rect y="0" width="126" height="14" fill="#FFCA05" />
      <rect y="14" width="126" height="14" fill="#EC1C24" />
      <rect y="28" width="126" height="14" fill="#FFCA05" />
      <rect y="42" width="126" height="14" fill="#EC1C24" />
      <rect y="56" width="126" height="14" fill="#FFCA05" />
      <rect y="70" width="126" height="14" fill="#EC1C24" />
      <rect y="84" width="126" height="14" fill="#FFCA05" />
      <rect y="98" width="126" height="14" fill="#EC1C24" />
      <rect y="112" width="126" height="14" fill="#FFCA05" />
    </g>
  </svg>
);
